import * as React from 'react';
import InvoiceContainer from './list';
import Collections from '../collections';
import ManualLineItemsIndex from '../line-items';

interface IProps {
    subTab: string
}

class InvoiceTransplant extends React.Component<IProps, {}> {
    render = () => {
        return (
            <>
                {this.props.subTab == 'INDEX' && (
                    <InvoiceContainer isAdmin={true}/>
                )}

                {this.props.subTab == 'LINE-ITEMS' && (
                    <ManualLineItemsIndex />
                )}

                {this.props.subTab == 'COLLECTIONS' && (
                    <Collections history={undefined} location={undefined} match={undefined} />
                )}
            </>
        );
    }
}

export default InvoiceTransplant;